import React from 'react';

import FileInputButton from './file.input.button';

export default React.forwardRef((props, ref) => (
  <FileInputButton {...props} forwardedRef={ref} />
));
